import fetcher from 'features/shared/utils/fetcher'
import { AnnotationModel, AnnotationPostModel } from '../types/annotation'

export async function getAnnotations(serviceId: number | undefined) {
  return await fetcher.get<{data: AnnotationModel[]}>(`/plans/${serviceId}/annotations`)
}

export async function createAnnotation(newAnnotation: AnnotationPostModel) {
    return await fetcher.post('/plan/annotations', newAnnotation)
}